export default __webpack_public_path__ + "static/media/started-image1.57aecaed.png";